import { useState } from 'react';
import { List, Calendar, Sparkles } from 'lucide-react';
import { TransactionsTab } from './TransactionsTab';
import { CashFlowTab } from './CashFlowTab';
import { CategorizationTab } from './CategorizationTab';

type SubTab = 'transactions' | 'categorization' | 'cashflow';

export function TreasuryTab() {
  const [activeSubTab, setActiveSubTab] = useState<SubTab>('transactions');

  const subTabs = [
    { id: 'transactions' as SubTab, label: 'Transactions', icon: List },
    { id: 'categorization' as SubTab, label: 'Catégorisation', icon: Sparkles },
    { id: 'cashflow' as SubTab, label: 'Plan de trésorerie', icon: Calendar }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
        <div className="flex gap-2 border-b border-gray-200">
          {subTabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveSubTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2.5 font-medium transition-all relative ${
                  activeSubTab === tab.id
                    ? 'text-blue-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <Icon size={18} />
                {tab.label}
                {activeSubTab === tab.id && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-t" />
                )}
              </button>
            );
          })}
        </div>
      </div>

      <div className="transition-opacity duration-200">
        {activeSubTab === 'transactions' && <TransactionsTab />}
        {activeSubTab === 'categorization' && <CategorizationTab />}
        {activeSubTab === 'cashflow' && <CashFlowTab />}
      </div>
    </div>
  );
}
